import axios from "axios";
import moment from "moment";

const baseURL =
  process.env.REACT_APP_NEW_IMAGE_UPLOAD_URL;
// ||"https://files.suprabhaatham.com/upload";

export const uploadImageWithProgress = async (
  file: File,
  onProgress: (percent: number) => void,
) => {
  const formData = new FormData();
  const filename = `${moment().format("YYYY-MM-DDHH:MM:SS")}${file.name}`;
  formData.append("image", file, filename);
  return axios.post(`${baseURL}`, formData, {
    onUploadProgress: (progressEvent) => {
      const total = progressEvent.total || 1;
      const percent = Math.round((progressEvent.loaded * 100) / total);
      onProgress(percent);
    },
  });
};

export const uploadVideoWithProgress = async (
  file: File,
  onProgress: (percent: number) => void,
) => {
  const formData = new FormData();
  const filename = `${moment().format("YYYY-MM-DDHH:MM:SS")}${file.name}`;
  formData.append("file", file, filename);
  return axios.post(`${baseURL}/video`, formData, {
    onUploadProgress: (progressEvent) => {
      const total = progressEvent.total || 1;
      const percent = Math.round((progressEvent.loaded * 100) / total);
      onProgress(percent);
    },
  });
};
